// 'use client';

import { useEffect } from 'react';
import { LocaleCode } from '@/utils/Locale';
import { getHsConfig } from '@/components/salesAndResourcesPage/contactHubspot';

interface ContactUsHubSpotProps {
    locale: LocaleCode;
}

const ContactUsHubSpot: React.FC<ContactUsHubSpotProps> = ({ locale }) => {
    const cfg = getHsConfig(locale);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const scriptId = 'hs-forms-script-v2';
        let retryCount = 0;
        let destroyed = false;

        const ensureContainer = () =>
            document.getElementById(cfg.containerId) as HTMLDivElement | null;

        const mountForm = () => {
            const container = ensureContainer();
            const w = window as any;

            if (!container || !w?.hbspt) {
                // 容器或 hbspt 尚未就緒，稍後重試一下（最多 10 次，每 150ms）
                if (!destroyed && retryCount++ < 10) {
                    setTimeout(mountForm, 150);
                }
                return;
            }

            // 清空容器，避免路由切換/重複掛載
            container.innerHTML = '';

            w.hbspt.forms.create({
                portalId: cfg.portalId,
                formId: cfg.formId,
                region: cfg.region,
                // 用「選擇器字串」，讓 HubSpot 100% 找到正確容器
                target: `#${cfg.containerId}`,
            });
        };

        const existing = document.getElementById(scriptId) as HTMLScriptElement | null;

        if (existing) {
            if ((window as any).hbspt) mountForm();
            else existing.addEventListener('load', mountForm, { once: true });
        } else {
            // 動態載入 HubSpot 表單腳本
            const s = document.createElement('script');
            s.id = scriptId;
            s.async = true;
            s.defer = true;
            s.src = cfg.scriptSrc;
            s.onload = mountForm;
            document.body.appendChild(s);
        }

        return () => {
            destroyed = true;
            // 卸載時清空容器，避免殘留 iframe
            const c = ensureContainer();
            if (c) c.innerHTML = '';
        };
    }, []);

    // 這個 div 的位置，就是表單應該出現的位置
    return (
        <div
            id={cfg.containerId}
            style={{
                width: '100%',
                // 讓容器有塊級排版，不會被奇怪的 flex/浮動影響
                display: 'block',
            }}
        />
    );
};

export default ContactUsHubSpot;
